export const extensionsType: { [key: string]: string } = {
  jpg: 'Photos&Image',
  jpeg: 'Photos&Image',
  png: 'Photos&Image',
  heic: 'Photos&Image',
  HEIC: 'Photos&Image',
  pdf: 'PDFs',
  odp: 'Presentations',
  ppt: 'Presentations',
  pps: 'Presentations',
  pptx: 'Presentations',
  ppsx: 'Presentations',
  pot: 'Presentations',
  potx: 'Presentations',
  doc: 'Documents',
  docx: 'Documents',
  txt: 'Documents',
  text: 'Documents',
  rtf: 'Documents',
  odt: 'Documents',
  xls: 'Spreadsheets',
  xlsx: 'Spreadsheets',
  csv: 'Spreadsheets',
};
